import React from "react"
import FaIcon from "components/fa_icon"

function PercentageBox({color, number, text}) {
  return (
    <div className={`percentage-box percentage-box--${color}`}>
      <div className="figure">
        <FaIcon name={"fa-crooked-arrow"}/>
        {number}
        <span className="percentage">%</span>
      </div>
      <div className="label">
        {text}
      </div>
    </div>
  )
}

export default PercentageBox
